<template>
  <div class="couponrecord">
    <HpsfirProTable
      ref="tableRef"
      :paginations="{ pageSize: 20 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"

      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="tsx" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';

const getFullUrl = (url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  }
  return useApi().baseUrl + url;
};

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();

const addInitValue = {
};

const conditionsInitValue = {
};

// 创建列定义
// eslint-disable-next-line max-lines-per-function
const createColumns = () => [
  {
    name: 'user',
    label: '用户信息',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 200,
    render(scope: any) {
      const { userInfo } = scope.row;
      if (!userInfo) {
        return <span>-</span>;
      }
      const { avatar, name, phone } = userInfo;
      return (
        <div class="user-info-cell">
          <el-avatar
            size={40}
            src={avatar ? getFullUrl(avatar) : ''}
          >
            {name ? name.charAt(0) : '?'}
          </el-avatar>
          <div class="user-detail">
            <div class="user-name">{name || '-'}</div>
            <div class="user-phone">{phone || '-'}</div>
          </div>
        </div>
      );
    },
  },
  {
    name: 'name',
    label: '券名称',
    type: 'string',
    rule: [{ required: true, message: '请输入券名称' }],
    width: 150,
  },
  {
    name: 'goods',
    label: '商品信息',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 280,
    render(scope: any) {
      const { goods } = scope.row;
      if (!goods) {
        return <span>-</span>;
      }
      return (
        <div class="goods-detail">
          <div class="goods-image">
            <el-image
              src={goods.image ? getFullUrl(goods.image) : ''}
              fit="cover"
              style="width: 60px; height: 60px; border-radius: 4px;"
            />
          </div>
          <div class="goods-info">
            <div class="goods-name">{goods.name || '-'}</div>
            <div class="goods-desc">{goods.description || '-'}</div>
            <div class="goods-price">¥ {goods.price || '0'}</div>
          </div>
        </div>
      );
    },
  },
  {
    name: 'userId',
    label: '用户',
    type: 'remoteSearchSelect',
    fetchOptions: async(query) => {
      const res = await useApi().userApi.pageUsersuser({
        conditions: {
          meta: `phone": "%${query}%"` as any,
        },
        pageQuery: {
          page: 0,
          pageSize: 10,
        },
      });
      return res.data.data?.data?.map((item: any) => ({
        label: `${item.meta.name}(${item.meta.phone})`,
        value: item.id,
      })) || [];
    },
    placeholder: '搜索手机号',
    isCondition: true,
    hideTable: true,
    width: 120,
  },
  {
    name: 'verifyTime',
    label: '核销时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 120,
    render(scope: any) {
      return <span>{scope.row.verifyTime || '未核销'}</span>;
    },
  },
  {
    name: 'timeRange',
    label: '核销时间',
    type: 'datepick',
    isCondition: true,
    hideTable: true,
    clearable: true,
    pickType: 'datetimerange',
    defaultTime: [
      dayjs().startOf('day')
        .toDate(),
      dayjs().endOf('day')
        .toDate(),
    ],
    width: 180,
  },
] as HpsfirProTableColumn[];


// 初始化
const init = useBaseAsync(() => {
  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().couponApi.pageCouponcoupon({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {
        isVerified: true,
      } as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
      timeRange: filter.conditions.timeRange && {
        start: filter.conditions.timeRange[0],
        end: filter.conditions.timeRange[1],
        field: 'verifyTime',
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.name || '未命名'}"吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().couponApi.addCouponcoupon({
    couponAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().couponApi.updateCouponcoupon({
    couponAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().couponApi.delCouponcoupon(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
